import { Typography } from 'antd';
import React from 'react';
import { func, string } from 'prop-types';
import { ReplyIcon } from './ReplyIcon';

const { Text } = Typography;

export const CommentQuote = ({ authorName = '', excerpt = '', onClick = () => {} }) => (
  <button type="button" className="ticket-comment-quote" onClick={onClick}>
    <ReplyIcon className="ticket-comment-quote__icon" />
    <Text strong className="ticket-comment-quote__author">{authorName}</Text>
    <Text type="secondary" className="ticket-comment-quote__excerpt">{excerpt}</Text>
  </button>
);

CommentQuote.propTypes = {
  authorName: string,
  excerpt: string,
  onClick: func,
};
